import React, { useContext } from "react";
import styles from "./Warning.module.scss";
import PathContext from "../../context/path";
const Warning = () => {
  const path = useContext(PathContext);
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.bg}>
          <img src={`${path}/img/warning-bg.webp`} alt="" />
        </div>
        <div className={styles.logo}>
          <img src={`${path}/img/logo.svg`} alt="" />
        </div>
        <div className={styles.desc}>Интерактивный фильм</div>
        <div className={styles.title}>Твой выбор</div>
        <div className={styles.icon}>
          <img src={`${path}/img/mobile-icon-warning-2.svg`} alt="" />
          <img src={`${path}/img/mobile-icon-warning.svg`} alt="" />
        </div>
        <div className={styles.text}>Пожалуйста, поверните телефон в горизонтальное положение</div>
      </div>
    </>
  );

}

export default Warning;
